import * as moment from 'moment';

export class LogEvent {

  public id: string;
  public event: string;
  public type: LogEventType;
  public source: string;
  public userId: string;
  public userEmail: string;
  public vehicle: string;
  public carrierId: string;
  public carrierName: string;
  public loadUuid: string;
  public loadId: string;
  public loadNumber: string;
  public stopId: string;
  public shipmentNumber: string;
  public locationRef: string;
  public createdAt: moment.Moment;
  public contextualData: string;
  public status: LogEventStatus;
  public resultBody: string;
  public consumerVersion: string;

  static fromDto(l: any): LogEvent {
    const logEvent: LogEvent = new LogEvent();

    logEvent.id              = l.id;
    logEvent.event           = l.event;
    logEvent.type            = l.type;
    logEvent.source          = l.source;
    logEvent.userId          = l.user_id;
    logEvent.userEmail       = l.user_email;
    logEvent.vehicle         = l.vehicle;
    logEvent.carrierId       = l.carrier_id;
    logEvent.carrierName     = l.carrier_name;
    logEvent.loadUuid        = l.load_uuid;
    logEvent.loadId          = l.load_id;
    logEvent.loadNumber      = l.load_number;
    logEvent.stopId          = l.stop_id;
    logEvent.shipmentNumber  = l.shipment_number;
    logEvent.locationRef     = l.location_ref;
    logEvent.createdAt       = moment(l.created_at);
    logEvent.contextualData  = l.contextual_data;
    logEvent.status          = l.status;
    logEvent.resultBody      = l.result_body;
    logEvent.consumerVersion = l.consumer_version;

    return logEvent;
  }
}

export enum LogEventStatus {
  SUCCEED           = 'SUCCEED',
  PARTIALLY_SUCCEED = 'PARTIALLY_SUCCEED',
  FAILED            = 'FAILED'
}

export enum LogEventType {
  LOG   = 'LOG',
  ERROR = 'ERROR'
}
